import { render, staticRenderFns } from "./clients.vue?vue&type=template&id=f4ff4c4a&scoped=true"
import script from "./clients.vue?vue&type=script&lang=ts"
export * from "./clients.vue?vue&type=script&lang=ts"
import style0 from "./clients.vue?vue&type=style&index=0&id=f4ff4c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ff4c4a",
  null
  
)

export default component.exports